var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { NOT_LOADED } from "../Infra/RemoteData";
export class PatientConsentPassDeviceViewModel extends PatientConsentViewModel {
    constructor() {
        super(...arguments);
        this.passDeviceType = null;
    }
    get isAdditionalParentGuardianExemptSignatureEnabled() {
        var _a, _b;
        return (_b = (this.study !== NOT_LOADED && ((_a = this.study) === null || _a === void 0 ? void 0 : _a.additionalParentGuardianExemptSignature))) !== null && _b !== void 0 ? _b : false;
    }
    get additionalParentGuardianExemptSignature() {
        var _a;
        return (_a = this.patientConsentUIManager.session.additionalParentGuardianExemptSignature) !== null && _a !== void 0 ? _a : false;
    }
    updateAdditionalParentGuardianExemptSignature(additionalParentGuardianExemptSignature) {
        this.patientConsentUIManager.updateAdditionalParentGuardianExemptSignature(additionalParentGuardianExemptSignature);
    }
    get isMinorParticipantExemptFromAssentEnabled() {
        var _a, _b;
        return (_b = (this.study !== NOT_LOADED && ((_a = this.study) === null || _a === void 0 ? void 0 : _a.minorParticipantExemptFromAssent))) !== null && _b !== void 0 ? _b : false;
    }
    get minorParticipantExemptFromAssent() {
        var _a;
        return (_a = this.patientConsentUIManager.session.minorParticipantExemptFromAssent) !== null && _a !== void 0 ? _a : false;
    }
    updateMinorParticipantExemptFromAssent(minorParticipantExemptFromAssent) {
        this.patientConsentUIManager.updateMinorParticipantExemptFromAssent(minorParticipantExemptFromAssent);
    }
    skipWitness() {
        if (this.passDeviceType === "witness") {
            this.patientConsentUIManager.updateWitnessSkipSignature(true);
            this.patientConsentUIManager.goToNextPage();
        }
    }
    isSkipWitnessButtonActive() {
        return this.isScreenshotMode && !!this.patientConsentUIManager.session.witnessSkipSignature;
    }
    async continue() {
        if (this.passDeviceType === "minor" && this.minorParticipantExemptFromAssent) {
            await this.confirmConsentOrGoToNextPage();
        }
        else {
            if (this.passDeviceType === "witness") {
                this.patientConsentUIManager.updateWitnessSkipSignature(false);
            }
            this.goToNextPage();
        }
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentPassDeviceViewModel.prototype, "isAdditionalParentGuardianExemptSignatureEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentPassDeviceViewModel.prototype, "additionalParentGuardianExemptSignature", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentPassDeviceViewModel.prototype, "isMinorParticipantExemptFromAssentEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentPassDeviceViewModel.prototype, "minorParticipantExemptFromAssent", null);
